(ns dre.modals.my-searches.signals.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.components.searchbar.events :as searchbar-events]
   [dre.modals.events :as-alias modals]
   [dre.network :as-alias network]
   [dre.pages.my-searches.signals.events :as s-events]
   [dre.utils.query :as q]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :my-searches :signals])

;; events

(rf/reg-event-fx
 ::init-delete
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [opts]]
  {:db opts}))

(rf/reg-event-fx
 ::init-edit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [opts]]
  {:db (-> (update opts :data-edit merge
                   {:search-query (-> opts :data-edit :query/search-query q/coerce)
                    :suggestions {:current nil}
                    :counts {:current nil
                             :loading? false}})
           (assoc :global-settings-state :loading))
   :dispatch [::searchbar-events/fetch-count
              (conj db-path :data-edit)
              {:search-query (-> opts :data-edit :query/search-query)}]
   ::network/request [{:endpoint :app/settings}
                      {:on-success [::success-settings]
                       :on-failure [::failure-settings]}]}))

(rf/reg-event-fx
 ::success-settings
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  {:db (-> db 
           (assoc :global-settings-state :success)
           (assoc :global-settings (:signals (:body response))))}))

(rf/reg-event-fx
 ::failure-settings
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (assoc db :global-settings-state :failure)
   :dispatch-n [[:dre.network/default-failure opts]]}))


(rf/reg-event-fx
 ::delete
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [data]]
  {:fx [[:dispatch [::modals/clear]]
        [:dispatch [::s-events/delete data]]]}))

(rf/reg-event-fx
 ::update-data-edit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [path value]]
  {:db (assoc-in db (cons :data-edit path) value)}))

(rf/reg-event-fx
 ::edit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [uuid signal]]
  {:fx [[:dispatch [::modals/clear]]
        [:dispatch [::s-events/edit uuid signal]]]}))

(rf/reg-event-fx
 ::add
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [signal]]
  {:fx [[:dispatch [::modals/clear]]
        [:dispatch [::s-events/add signal]]]}))

;; subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

(rf/reg-sub
 ::data-delete
 :<- [::state]
 (fn [db _]
   (get db :data-delete)))

(rf/reg-sub
 ::data-edit
 :<- [::state]
 (fn [db _]
   (get db :data-edit)))

(rf/reg-sub
 ::global-settings
 :<- [::state]
 (fn [db _]
   (get db :global-settings)))

(rf/reg-sub
 ::global-settings-state
 :<- [::state]
 (fn [db _]
   (get db :global-settings-state)))

